// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"173":"602bac2f","528":"8ae9cf36"}[chunkId] + ".chunk.css";
};